import { StandardGrid, StandardGridPresentationType } from '@apply/components';
import { IBridgeApplicationGridRecord, IBridgeApplicationPropertyGridRecord } from '@apply/api/src/api/applicationApi.ts';
import { Column } from 'devextreme-react/data-grid';
import { applicationCityRender } from '../../../../common/functions/renderers/applicationCityRender.tsx';
import { applicationStateRender } from '../../../../common/functions/renderers/applicationStateRender.tsx';
import { formatBoolAsYN } from '../../../../../../common/functions/formatters/formatBoolAsYN.tsx';
import { formatDecimalAsTwoDigitPercentage } from '../functions/formatters/formatDecimalAsTwoDigitPercentage.tsx';
import { appraisedCellRender } from '../functions/renderers/appraisedCellRender.tsx';
import { actionCellRender } from './renderers/actionCellRender.tsx';

export interface ApplicationsPortfolioPropertiesGridProps {
    application: IBridgeApplicationGridRecord;
    data: IBridgeApplicationPropertyGridRecord[];
}

export const ApplicationsPortfolioPropertiesGrid = ({ application, data }: ApplicationsPortfolioPropertiesGridProps) => {
    return (
        <>
            <div className='subGrid'>
                <StandardGrid
                    dataSource={data}
                    keyExpr='applicationPropertyId'
                    presentationType={StandardGridPresentationType.Enhanced}
                    noDataText='No Applications Found'
                    pagerVisible={false}
                    rowAlternationEnabled={true}
                    showColumnHeaders={true}
                    showBorders={true}
                    remoteOperations={false}
                    allowColumnReordering={false}
                    width={1100}
                >
                    <Column
                        dataField='portfolioLoan'
                        caption='Loan'
                        width={100}
                        alignment='left'
                    />
                    <Column
                        dataField='street'
                        caption='Street'
                        alignment='left'
                        width={200}
                    />
                    <Column
                        dataField='city'
                        caption='City'
                        width={120}
                        alignment='left'
                        cellRender={(e) => applicationCityRender(e)}
                    />
                    <Column
                        dataField='state'
                        caption='State'
                        width={50}
                        alignment='left'
                        cellRender={(e) => applicationStateRender(e)}
                    />
                    <Column
                        dataField='bfiRefi'
                        caption='BFI Refi'
                        width={70}
                        alignment='left'
                        dataType='string'
                        customizeText={(e) => formatBoolAsYN(e.value)}
                    />
                    <Column
                        dataField='units'
                        caption='Units'
                        width={50}
                        alignment='left'
                    />
                    <Column
                        dataField='estimatedSize'
                        caption='Est. Size'
                        width={100}
                        alignment='left'
                        format={'currency'}
                    />
                    <Column
                        dataField='ltv'
                        caption='LTV'
                        width={60}
                        alignment='left'
                        customizeText={(e) => formatDecimalAsTwoDigitPercentage(e.value)}
                    />
                    <Column
                        caption='Appraised'
                        width={100}
                        alignment='left'
                        cellRender={(cellInfo) =>
                            appraisedCellRender({
                                status: cellInfo.data.appraisalStatusTypeId,
                                appraisalAmount: cellInfo.data.appraisalAmount,
                                appraisalReceivedDate: cellInfo.data.appraisalReceivedDate,
                            })
                        }
                    />
                    <Column
                        dataField='exception'
                        caption='Exception'
                        alignment='left'
                        width={200}
                    />
                    <Column
                        alignment='center'
                        cellRender={(e) => actionCellRender(application, e)}
                        width={40}
                        allowReordering={false}
                        allowSorting={false}
                        allowResizing={false}
                        type='buttons'
                        fixed={true}
                        fixedPosition={'right'}
                    />
                </StandardGrid>
            </div>
        </>
    );
};
